module.exports = __webpack_public_path__ + "static/media/physics-che-big@2x.119cca46.png";